import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core'
import { AutomationEventTypes, AutomationTypes } from '@tokeet-frontend/automations'
import { UntypedFormBuilder, Validators } from '@angular/forms'
import { select, Store } from '@ngrx/store'
import { selectAllRentals, selectUsers } from '@tokeet-frontend/tv3-platform'
import { AutomationWizardPanelBaseComponent } from '@tv3/containers/automations/automations-wizard/automation-wizard-panel.component'
import {
  guestReviewNotificationMessages,
  userReviewNotificationMessages,
} from '@tv3/containers/automations/automations-wizard/review/messages'
import { guestBookingNotificationMessages } from '@tv3/containers/automations/automations-wizard/booking/messages'
import { channelReviewSourceOptions, ChannelReviewSources } from '@tokeet-frontend/reviews'
import { Actions } from '@ngrx/effects'

@Component({
  selector: 'app-review-automation-wizard',
  templateUrl: './review-automation-wizard.component.html',
  styleUrls: ['./review-automation-wizard.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ReviewAutomationWizardComponent extends AutomationWizardPanelBaseComponent {
  type = AutomationTypes.Review

  rentals$ = this.store.pipe(select(selectAllRentals))
  channels = channelReviewSourceOptions.filter((t) => t.reviewable)

  guestNotificationMessages = guestReviewNotificationMessages
  userNotificationMessages = userReviewNotificationMessages
  constructor(protected fb: UntypedFormBuilder, protected actions: Actions, protected store: Store<any>) {
    super(actions, store, fb)

    this.form.get('channels').setValidators([Validators.required])

    this.form.patchValue({ event: AutomationEventTypes.ReviewHostSubmitted, channels: [ChannelReviewSources.Airbnb] })
  }
}
